import React from 'react';
import { MidnightLogo } from './svgs/MidnightLogo';
import { WhiteLogo } from './svgs/WhiteLogo';
export const Logo = ({ className, color = 'midnight', }) => {
    if (color === 'midnight') {
        return React.createElement(MidnightLogo, { className: className });
    }
    return React.createElement(WhiteLogo, { className: className });
};
//# sourceMappingURL=Logo.js.map